














import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import { IRules } from './UI/Form/ValidationModule';

@Component
export default class ValueConfirmation<T> extends Vue {
  @Prop({ required: true }) private value!: T;
  @PropSync('confirmed', { type: Boolean, required: true }) private confirmedSync!: boolean;
  @Prop({ type: Function, default: () => true }) private condition!: (value: T) => boolean;

  private internalValue: T | null = null;
  private touched = false;

  @Watch('value')
  private setTouched(): void {
    this.touched = true;
  }

  @Watch('value', { immediate: true })
  @Watch('internalValue')
  private setConfirmed(): void {
    this.confirmedSync = !this.shouldConfirm || this.confirmationChecker(this.value, this.internalValue);
  }

  private get shouldConfirm(): boolean {
    return this.touched && this.condition(this.value);
  }

  private setInternalValue(value: T): void {
    this.internalValue = value;
  }

  @Watch('value')
  @Watch('shouldConfirm')
  private resetInternalValue(): void {
    this.internalValue = null;
  }

  private confirmationRules: IRules = {
    confirmation: [
      {
        validation: ({ dataValue }) => this.confirmationChecker(this.value, dataValue),
        message: i18n => i18n.t('pleaseConfirm'),
      },
    ],
  }

  private confirmationChecker(value: T, confirmationValue: T | null): boolean {
    return confirmationValue === value;
  }
}
